var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sub-lg:u-text-center u-pt-30p u-pb-10 lg:u-pt-5 lg:u-pb-80p"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}})
}]

export { render, staticRenderFns }